{"W":"K",
 "N":"K",
 "AA":"K",
 "AB":"K",
 "AC":"K",
 "AD":"K",
 "AE":"K",
 "AF":"K",
 "AG":"K",
 "AI":"K",
 "AJ":"K",
 "AK":"K",
 "AL":"KL",
 "KA":"K",
 "KB":"K",
 "KC":"K",
 "KD":"K",
 "KE":"K",
 "KF":"K",
 "KG":"K",
 "KI":"K",
 "KJ":"K",
 "KK":"K",
 "KM":"K",
 "KN":"K",
 "KO":"K",
 "KQ":"K",
 "KR":"K",
 "KS":"K",
 "KT":"K",
 "KU":"K",
 "KV":"K",
 "KW":"K",
 "KX":"K",
 "KY":"K",
 "KZ":"K",
 "WA":"K",
 "WB":"K",
 "WC":"K",
 "WD":"K",
 "WE":"K",
 "WF":"K",
 "WG":"K",
 "WI":"K",
 "WJ":"K",
 "WK":"K",
 "WL":"KL",
 "WM":"K",
 "WN":"K",
 "WO":"K",
 "WP":"KP4",
 "WQ":"K",
 "WR":"K",
 "WS":"K",
 "WT":"K",
 "WU":"K",
 "WV":"K",
 "WW":"K",
 "WX":"K",
 "WY":"K",
 "WZ":"K",
 "NA":"K",
 "NB":"K",
 "NC":"K",
 "ND":"K",
 "NE":"K",
 "NF":"K",
 "NG":"K",
 "NI":"K",
 "NJ":"K",
 "NK":"K",
 "NL":"KL",
 "NM":"K",
 "NN":"K",
 "NO":"K",
 "NP":"KP4",
 "NQ":"K",
 "NR":"K",
 "NS":"K",
 "NT":"K",
 "NU":"K",
 "NV":"K",
 "NW":"K",
 "NX":"K",
 "NY":"K",
 "NZ":"K",
 "DA":"DL",
 "DB":"DL",
 "DC":"DL",
 "DD":"DL",
 "DE":"DL",
 "DF":"DL",
 "DG":"DL",
 "DH":"DL",
 "DI":"DL",
 "DJ":"DL",
 "DK":"DL",
 "DM":"DL",
 "DN":"DL",
 "DO":"DL",
 "DP":"DL",
 "DQ":"DL",
 "DR":"DL",
 "PP":"PY",
 "PQ":"PY",
 "PR":"PY",
 "PS":"PY",
 "PT":"PY",
 "PU":"PY",
 "PV":"PY",
 "PW":"PY",
 "ZV":"PY",
 "ZW":"PY",
 "ZX":"PY",
 "ZY":"PY",
 "ZZ":"PY",
 "PX0F":"PY0F",
 "PX":"PY",
 "RA":"UA",
 "RV":"UA",
 "RW":"UA",
 "RX":"UA",
 "RZ":"UA",
 "U":"UA",
 "IK":"I",
 "IN":"I",
 "IU":"I",
 "IW":"I",
 "IX":"I",
 "IY":"I",
 "IZ":"I",
 "EB":"EA",
 "EC":"EA",
 "ED":"EA",
 "EE":"EA",
 "EF":"EA",
 "EG":"EA",
 "EH":"EA",
 "AM":"EA",
 "AN":"EA",
 "AO":"EA",
 "SN":"SP",
 "SO":"SP",
 "SQ":"SP",
 "SR":"SP",
 "HF":"SP",
 "3Z":"SP",
 "SA":"SM",
 "SB":"SM",
 "SC":"SM",
 "SD":"SM",
 "SE":"SM",
 "SF":"SM",
 "SG":"SM",
 "SH":"SM",
 "SI":"SM",
 "SJ":"SM",
 "SK":"SM",
 "SL":"SM",
 "LO":"LU",
 "LP":"LU",
 "LQ":"LU",
 "LR":"LU",
 "LS":"LU",
 "LT":"LU",
 "LV":"LU",
 "LW":"LU",
 "AY":"LU",
 "AZ":"LU",
 "L2":"LU",
 "L3":"LU",
 "L4":"LU",
 "L5":"LU",
 "L6":"LU",
 "L7":"LU",
 "L8":"LU",
 "L9":"LU",
 "OO":"ON",
 "OP":"ON",
 "OQ":"ON",
 "OR":"ON",
 "OS":"ON",
 "OT":"ON",
 "OG":"OH",
 "OI":"OH",
 "OF":"OH",
 "OL":"OK",
 "M":"G",
 "2E":"G",
 "2M":"GM",
 "MM":"GM",
 "MW":"GW",
 "MI":"GI",
 "MD":"GD",
 "MJ":"GJ",
 "MU":"GU",
 "2W":"GW",
 "2I":"GI",
 "2D":"GD",
 "2J":"GJ",
 "2U":"GU",
 "JE":"JA",
 "JF":"JA",
 "JG":"JA",
 "JH":"JA",
 "JI":"JA",
 "JJ":"JA",
 "JK":"JA",
 "JL":"JA",
 "JM":"JA",
 "JN":"JA",
 "JO":"JA",
 "JP":"JA",
 "JQ":"JA",
 "JR":"JA",
 "JS":"JA",
 "7J":"JA",
 "7K":"JA",
 "7L":"JA",
 "7M":"JA",
 "7N":"JA",
 "DS":"HL",
 "D7":"HL",
 "D8":"HL",
 "D9":"HL",
 "6K":"HL",
 "6L":"HL",
 "6M":"HL",
 "6N":"HL",
 "US":"UR",
 "UT":"UR",
 "UU":"UR",
 "UV":"UR",
 "UW":"UR",
 "UX":"UR",
 "UY":"UR",
 "UZ":"UR",
 "EM":"UR",
 "EN":"UR",
 "EO":"UR",
 "HE":"HB",
 "CA":"CE",
 "CB":"CE",
 "CC":"CE",
 "CD":"CE",
 "XQ":"CE",
 "XR":"CE",
 "3G":"CE",
 "3F":"CE",
 "E2":"HS",
 "SW":"SV",
 "SX":"SV",
 "SY":"SV",
 "SZ":"SV",
 "J4":"SV",
 "HG":"HA",
 "CQ":"CT",
 "CR":"CT",
 "CS":"CT",
 "HO":"HP",
 "H3":"HP",
 "H8":"HP",
 "H9":"HP",
 "HQ":"HR",
 "HT":"YN",
 "H7":"YN",
 "CL":"CM",
 "CO":"CM",
 "T4":"CM",
 "HU":"YS",
 "TD":"TG",
 "YP":"YO",
 "YQ":"YO",
 "YR":"YO",
 "YT":"YU",
 "4N":"YU",
 "CW":"CX",
 "CV":"CX",
 "OB":"OA",
 "OC":"OA",
 "YW":"YV",
 "YX":"YV",
 "YY":"YV",
 "4M":"YV",
 "5J":"HK",
 "5K":"HK",
 "HD":"HC",
 "AT":"VU",
 "8T":"VU",
 "8W":"VU",
 "BA":"BY",
 "BD":"BY",
 "BT":"BY",
 "BG":"BY",
 "BH":"BY",
 "BI":"BY",
 "7Z":"HZ",
 "8Z":"HZ",
 "TM":"F",
 "TP":"F",
 "4A":"XE",
 "4B":"XE",
 "4C":"XE",
 "6D":"XE",
 "6E":"XE",
 "6F":"XE",
 "TE":"TI",
 "HJ":"HK",
 "5O":"5N",
 "5I":"5H",
 "5Y":"5Z",
 "9I":"9J",
 "Z21":"Z2",
 "9W":"9M2",
 "LB":"LA",
 "LC":"LA",
 "LD":"LA",
 "LE":"LA",
 "LF":"LA",
 "LG":"LA",
 "LH":"LA",
 "LI":"LA",
 "LJ":"LA",
 "LK":"LA",
 "LL":"LA",
 "LM":"LA",
 "LN":"LA",
 "ZR":"ZS",
 "ZT":"ZS",
 "ZU":"ZS",
 "PB":"PA",
 "PC":"PA",
 "PD":"PA",
 "PE":"PA",
 "PF":"PA",
 "PG":"PA",
 "PH":"PA",
 "PI":"PA",
 "OU":"OZ",
 "OV":"OZ",
 "OW":"OZ",
 "5P":"OZ",
 "5Q":"OZ",
 "EJ":"EI",
 "VA":"VE",
 "VB":"VE",
 "VC":"VE",
 "VD":"VE",
 "VE":"VE",
 "VG":"VE",
 "VO":"VE",
 "VX":"VE",
 "VY":"VE",
 "AX":"VK",
 "VH":"VK",
 "VI":"VK",
 "VJ":"VK",
 "VL":"VK",
 "VM":"VK",
 "VN":"VK",
 "ZK":"ZL",
 "ZM":"ZL",
 "9Z":"9Y",
 "EV":"EU",
 "EW":"EU",
 "6A":"SU",
 "SS":"SU",
 "5C":"CN",
 "5D":"CN",
 "5E":"CN",
 "5F":"CN",
 "5G":"CN",
 "7Y":"7X",
 "TS":"3V",
 "S6":"9V",
 "VS":"VR",
 "BM":"BV",
 "BN":"BV",
 "BO":"BV",
 "BP":"BV",
 "BQ":"BV",
 "BU":"BV",
 "BW":"BV",
 "BX":"BV",
 "EQ":"EP",
 "9B":"EP",
 "9C":"EP",
 "AS":"AP",
 "6P":"AP",
 "6Q":"AP",
 "6R":"AP",
 "6S":"AP",
 "UJ":"UK",
 "UL":"UK",
 "UM":"UK",
 "UP":"UN",
 "UQ":"UN",
 "HN":"YI",
 "TB":"TA",
 "TC":"TA",
 "YM":"TA",
 "XV":"3W",
 "P3":"5B",
 "4Z":"4X",
 "YC":"YB",
 "YD":"YB",
 "YE":"YB",
 "YF":"YB",
 "YG":"YB",
 "YH":"YB",
 "8A":"YB",
 "8B":"YB",
 "8C":"YB",
 "8D":"YB",
 "8E":"YB",
 "8F":"YB",
 "8G":"YB",
 "8H":"YB",
 "8I":"YB",
 "7A":"YB",
 "7B":"YB",
 "7C":"YB",
 "7D":"YB",
 "7E":"YB",
 "7F":"YB",
 "7G":"YB",
 "7H":"YB",
 "7I":"YB",
 "AL7":"KL",
 "NL7":"KL",
 "WL7":"KL",
 "NH":"KH6",
 "WH":"KH6",
 "AH":"KH6"}
